export default "__VITE_ASSET__9e48de7e__"